import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllServices } from "../api";
import { applianceMeta } from "../constants";
import { ArrowRight, Check } from "lucide-react";

export default function ServicesOverview() {
  const [byAppliance, setByAppliance] = useState({});

  useEffect(() => {
    getAllServices().then((items) => {
      const g = {};
      items.forEach((s) => { (g[s.appliance] ||= []).push(s); });
      setByAppliance(g);
    }).catch(() => {});
  }, []);

  return (
    <section className="py-20 bg-white border-t border-neutral-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="chip mb-4">Services</div>
            <h2 className="font-display text-3xl md:text-5xl font-medium leading-tight max-w-2xl">Every service, done the Elica way</h2>
          </div>
          <p className="text-slate-500 max-w-md">Below is what we can help with today. If your issue isn&apos;t listed, WhatsApp us – we&apos;ll advise honestly.</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Object.values(applianceMeta).map((a) => (
            <div key={a.slug} className="p-6 rounded-lg border border-neutral-200 hover-card bg-white">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-display text-xl font-medium">Elica {a.title}</h3>
                <Link to={a.route} className="text-xs font-semibold text-[#e30613] uppercase tracking-wider inline-flex items-center gap-1">Details <ArrowRight className="w-3.5 h-3.5" /></Link>
              </div>
              <ul className="space-y-2">
                {(byAppliance[a.slug] || []).map((s) => (
                  <li key={s.id} className="flex items-start gap-2 text-sm text-slate-700">
                    <Check className="w-4 h-4 text-[#e30613] mt-0.5 flex-shrink-0" />
                    <span>{s.title}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
